/**
 * TODO будет перенесено в утилиты и покрыто тестами в https://cianru.atlassian.net/browse/CD-38432
 */
export type ExceptionLogger = (ex: Error, options?: unknown) => Error;

const defaultExceptionLogger: ExceptionLogger = (ex: Error) => {
  if (typeof (console as Console | undefined) !== 'undefined' && console.error) {
    console.error(ex);
  }

  return ex;
};

let currentLogger = defaultExceptionLogger;

export const setExceptionLogger = (logger: ExceptionLogger) => {
  currentLogger = logger;
};

//tslint:disable-next-line:no-any
export const logException = (ex: Error, options?: unknown) => {
  return currentLogger(ex, options);
};
